import * as React from "react";
import { DynamicForm } from "../../util/DynamicForm";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import MutationHandler from "../../util/MutationHandler";
import { apiGet, apiPost } from "../../util/axiosUtil";
import API_URL from "../../config/apiConfig";
import { z } from "zod";

export default function LinkMeeting({ onCancel, data, onSuccess }) {
  const [meetingOptions, setMeetingOptions] = React.useState([]);
  const [loadingmeetings, setLoadingMeetings] = React.useState(true);
  const FETCH_MEETINGS_URL = `${API_URL}/api/meetings/without-host`;

  // Fetch available plans
  React.useEffect(() => {
    const fetchMeetings = async () => {
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      try {
        const response = await apiGet(FETCH_MEETINGS_URL);
        const options =
          response?.data?.data?.map((meeting) => ({
            id: meeting.id,
            name: meeting.name,
          })) || [];
        setMeetingOptions(options);
        setLoadingMeetings(false);
      } catch (error) {
        console.error("Error fetching meeting:", error);
      }
    };

    fetchMeetings();
  }, []);

  const formConfig = {
    meeting: {
      label: "Meeting",
      type: "select",
      options: meetingOptions,
      defaultValue: "",
      required: false,
      isLoadingOptions: loadingmeetings,
      validation: z.preprocess(
        (val) => (val === "" || val == null ? undefined : Number(val)),
        z.number().positive("Invalid meeting").optional()
      ),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) =>
        apiPost(
          `${API_URL}/api/hosts/${data.id}/assign-meeting/${formData.meeting}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
      }
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <RechargeForm
          formConfig={formConfig}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
        />
      )}
    </MutationHandler>
  );
}

function RechargeForm({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Link Meeting"}
    />
  );
}
